import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ChevronsDoubleSVG } from '@common_components/svg/chevronsDouble.svg';

const ChevronsRightIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <ChevronsDoubleSVG/>
    </div>
  );
};

export { ChevronsRightIcon };
